// layouts/certificaciones/dataCertificaciones.js

/* eslint-disable react/prop-types */
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import { ui } from "ui/tokens";

export const columns = [
  { name: "titulo", align: "left", sortable: true },
  { name: "artista", align: "left", sortable: true },
  { name: "sello", align: "left", sortable: true },
  { name: "award", align: "left", sortable: true },
  { name: "creado", align: "center", sortable: true },
  { name: "estatus", align: "center" },
  { name: "pdf", align: "center" },
  { name: "action", align: "center" }, // 👈 clave consistente con otros catálogos
];

export default function buildTable(items = [], map) {
  const rows = (items || []).map((it, idx) => {
    const r =
      typeof map === "function"
        ? map(it, idx)
        : {
            id: it.id ?? it._id ?? idx,
            titulo: it.title ?? "-",
            artista: it.artist ?? "-",
            sello: it.sello ?? "—",
            award: it.award ?? "—",
            creado: it.created_at ?? it.createdAt,
            estatus: it.estatus,
            pdf: it.pdf,
            onEdit: null,
            onDelete: null,
          };

    const fecha = r.creado ? new Date(r.creado) : null;

    return {
      titulo: (
        <SoftTypography variant="button" fontWeight="medium">
          {r.titulo || "—"}
        </SoftTypography>
      ),
      artista: (
        <SoftTypography variant="button" color="text">
          {r.artista || "—"}
        </SoftTypography>
      ),
      sello: (
        <SoftTypography variant="button" color="text">
          {r.sello || "—"}
        </SoftTypography>
      ),
      award: (
        <SoftTypography variant="button" color="text">
          {r.award || "—"}
        </SoftTypography>
      ),
      creado: (
        <SoftTypography variant="caption" color="secondary" fontWeight="medium">
          {fecha ? fecha.toLocaleDateString() : "—"}
        </SoftTypography>
      ),
      estatus: r.estatus,
      pdf: r.pdf || null,

      // 👇 clave "action" para que la columna se pinte bien
      action: (
        <SoftBox display="flex" justifyContent="center" gap={0.5}>
          {typeof r.onEdit === "function" && (
            <Tooltip title="Editar">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  r.onEdit(r);
                }}
                sx={{
                  "& .icon-edit": { color: ui.icon?.edit?.base || "#0ea5e9" },
                  "&:hover .icon-edit": { color: ui.icon?.edit?.hover || "#0284c7" },
                  transition: "transform .15s ease",
                  "&:hover": { transform: "scale(1.12)" },
                }}
              >
                <Icon className="icon-edit" fontSize="small">
                  edit
                </Icon>
              </IconButton>
            </Tooltip>
          )}
      
          {typeof r.onDelete === "function" && (
            <Tooltip title="Eliminar">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  r.onDelete(r);
                }}
                sx={{
                  "& .icon-del": { color: ui.icon?.del?.base || "#ef4444" },
                  "&:hover .icon-del": { color: ui.icon?.del?.hover || "#b91c1c" },
                  transition: "transform .15s ease",
                  "&:hover": { transform: "scale(1.12)" },
                }}
              >
                <Icon className="icon-del" fontSize="small">
                  delete
                </Icon>
              </IconButton>
            </Tooltip>
          )}
        </SoftBox>
      ),
      
    };
  });

  return { columns, rows };
}
